module.exports = __webpack_public_path__ + "static/media/drawer-image.abd303c2.svg";